import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import Checkbox from '@components/Checkbox';
import DateFilter from '@components/DateFilter';
import { DeliveryHistoryFilters } from '@components/DeliveryHistoryFilters';
import { Input, Button } from '@stats/playbook-components';

const Filters = styled.div`
  .filter {
    display: inline-block;
    margin-bottom: 20px;
    input {
      width: 260px;
      height: 32px;
      background-color: rgba(242, 242, 242, 1);
      margin-right: 24px;
      box-sizing: border-box;
      border-radius: 2px;
      border: solid 1px rgba(226, 226, 226, 1);
    }
  }
`;

const GlobalSearchContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .search-input {
    width: 260px;
    margin-right: 10px;
  }

  button {
    margin-left: 5px;
  }
`;

const CheckBoxWrap = styled.div`
  label {
    display: inline-block;
  }
`;

interface FiltersContainerProps {
  fromDate: Date;
  toDate: Date;
  onDateChange: (e: any) => void;
  fileFilter: string;
  typeFilter: string;
  leagueFilter: string;
  onFilterSubmit: (filters: any) => void;
  errorOnly: boolean;
  onErrorCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  globalSearchInput: string;
  onGlobalSearchChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
  globalSearch: string;
  maxDaysInPast?: number;
}

const DeliveryHistoryFiltersContainer: React.FC<FiltersContainerProps> = ({
  fromDate,
  toDate,
  onDateChange,
  fileFilter,
  typeFilter,
  leagueFilter,
  onFilterSubmit,
  errorOnly,
  onErrorCheckboxChange,
  globalSearchInput,
  onGlobalSearchChange,
  onClearSearch,
  globalSearch,
  maxDaysInPast = 14
}) => {

  return (
    <Filters>
      <DateFilter
        fromDateVal={fromDate}
        toDateVal={toDate}
        setDateFilter={onDateChange}
        maxDaysInPast={maxDaysInPast}
      />
      <DeliveryHistoryFilters
        filename={fileFilter} 
        type={typeFilter}
        league={leagueFilter}
        onSubmit={onFilterSubmit} 
      />

      <GlobalSearchContainer>
        <Input
          value={globalSearchInput}
          label="Global Search"
          className="search-input"
          onChange={onGlobalSearchChange}
          placeholder="Type to search across all fields"
        />
        {globalSearch && (
          <Button variant="secondary-dark" onClick={onClearSearch}>
            Clear
          </Button>
        )}
      </GlobalSearchContainer>

      <CheckBoxWrap>
        <Checkbox
          checked={errorOnly}
          label="Display Only Errors"
          id="error-checkbox"
          onChange={onErrorCheckboxChange}
          size="medium"
        />
      </CheckBoxWrap>
    </Filters>
  );
};

export default DeliveryHistoryFiltersContainer;
